import {
  App,
  Bike,
  Car,
  Claim,
  Details,
  FSSAI,
  FaceBook,
  IRDAI,
  Instagram,
  Life,
  LinkedIn,
  Login,
  Logout,
  Message,
  PDC,
  Policy,
  Profile,
  Tracking,
  X,
  YouTube,
  Luggage,
  Menu,
  Location,
  Shield,
  HealthCheckup,
  Bolt,
  Money,
  DriverCoverPaid,
  Phone,
  Mail,
} from '@quark/icons'

export const getIcon = name => {
  if (!name) return undefined
  const icons = {
    Details: <Details />,
    App: <App />,
    Message: <Message />,
    Claim: <Claim />,
    Car: <Car />,
    Bike: <Bike />,
    Life: <Life />,
    Login: <Login />,
    Logout: <Logout />,
    Profile: <Profile />,
    Policy: <Policy />,
    Tracking: <Tracking />,
    Instagram: <Instagram />,
    LinkedIn: <LinkedIn />,
    X: <X />,
    YouTube: <YouTube />,
    FaceBook: <FaceBook />,
    PDC: <PDC />,
    FSSAI: <FSSAI />,
    IRDAI: <IRDAI />,
    Luggage: <Luggage />,
    Menu: <Menu />,
    Location: <Location />,
    Shield: <Shield />,
    HealthCheckup: <HealthCheckup />,
    Bolt: <Bolt />,
    Money: <Money />,
    DriverCoverPaid: <DriverCoverPaid />,
    Phone: <Phone />,
    Mail: <Mail />,
  }
  return icons[name]
}
